<template>
  <v-responsive 
    :aspect-ratio="16/9"
    class="bg-black"
    :style="{
      margin: orientation == 'horizontal' ? '-1px': '',
      maxHeight: `${videoHeight}px`,
    }"
  >
    <vimeo-player
      v-show="playerReady"
      ref="player"
      class="d-flex justify-center align-center"
      :video-id="content.content"
      :player-height="videoHeight"
      :options="options"
      @ready="onReady"
      @play="play"
      @fullscreenchange="onFullscreenchange"
      @pause="pause"
      @mute="onMute"
      @ended="onEnded"
    />
  </v-responsive>
</template>
<script>

import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'
Vue.use(vueVimeoPlayer)
import PlayerOptionsMixin from './PlayerOptionsMixin';

export default {
  mixins: [PlayerOptionsMixin],
  watch:{
   // Apenas observar quando a porcentagem minima do vídeo chegar na porcentagem minima a ser assistida então realizar o desejado
   percentageWatched:{
    handler(){

      if(this.content.finished_at) return;


      if((this.percentageWatched >= this.minimumPercentageWatch) || this.selectedCycle.is_finished){
        // Quando chega na porcentagem minima ou o ciclo selecionado ja finalizou libera o conteúdo do vídeo para a conclusão
        this.SET_MODULE({
              ...this.module,
              contents: this.module.contents.map(c => {
                if(c.id == this.content.id){
                  c.released_to_finish = true
                  c.percentage_watched = this.percentageWatched
                  c.left_seconds = 0
                }
                return c
              })
            })
      }else {
        // Enquanto não chega na porcentagem minima de video assistido incrementa a contagem do que foi assistido
        this.SET_MODULE({
              ...this.module,
              contents: this.module.contents.map(c => {
                if(c.id == this.content.id){
                  c.released_to_finish = false
                  c.percentage_watched = this.percentageWatched
                  c.left_seconds = this.secondsDuration > 0 ? this.secondsDuration - this.secondsWatched : 300
                }
                return c
              })
            })
      }
      if(this.percentageWatched>=99){
        clearInterval(this.updateTimeId)
      }
    },
    immediate: true,
   },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  destroyed() {
    clearInterval(this.updateTimeId)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        this.pause();
      }
    },
  },
}
</script>
<style lang="scss" scoped>
iframe {
  height: 100% !important;
}
</style>